import React, { useEffect, useRef } from "react";
import "./Vdo_wala_vdo_holder.css";

function Vdo_wala_vdo_holder() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.4; // Adjust this value to control the speed (0.5 = half speed)
    }
  }, []);

  return (
    <section className="Vdo_wala_vdo_holder">
      <video
        ref={videoRef}
        className="vdo_wala_vdo"
        src={
          process.env.PUBLIC_URL +
          "/Assets/Vedio/Vdo_Wala_bus_vdo/Bus Animation.mp4"
        }
        autoPlay
        loop
        muted
      />
    </section>
  );
}

export default Vdo_wala_vdo_holder;
